import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { PROBE_GET_SAMPLE_REQUEST } from 'js/constants/actionTypes';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import CircularLoader from 'js/components/elements/progress/CircularLoader';

interface PreviewButtonProps {
  onClick: (e) => void;
  requestKey?: string;
  className?: string;
  dataTableName?: string;
}

const PreviewButton = ({
  onClick,
  className,
  requestKey = PROBE_GET_SAMPLE_REQUEST,
  ...otherProps
}: PreviewButtonProps) => {
  const [loading, setLoading] = useState(false);
  const isProbeSampleLoading = useIsLoading(requestKey);

  const handleClick = (e) => {
    setLoading(true);
    onClick(e);
  };

  useEffect(() => {
    if (loading && !isProbeSampleLoading) {
      setLoading(false);
    }
  }, [isProbeSampleLoading]);

  return (
    <Button
      className={className}
      onClick={handleClick}
      variant="outlined"
      size="small"
      color="basic"
      data-testid="preview-button"
      style={{
        width: loading ? '74px' : 'auto',
      }}
      {...otherProps}
    >
      {loading && <CircularLoader size={22} thickness={1} color="var(--color-greyscale-600)" />}

      {!loading && 'Preview'}
    </Button>
  );
};

export default PreviewButton;
